const SvgIcon = ({ color = '#fff', size = '24' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    version="1.1"
    viewBox="0 0 24 24"
  >
    <path
      fill={color}
      stroke="none"
      strokeWidth="2.182"
      d="M12 0C5.386 0 0 5.386 0 12s5.386 12 12 12 12-5.386 12-12S18.614 0 12 0m0 2.182A9.8 9.8 0 0 1 21.818 12 9.8 9.8 0 0 1 12 21.818 9.8 9.8 0 0 1 2.182 12 9.8 9.8 0 0 1 12 2.182"
      color="#000"
    ></path>
    <path
      fill={color}
      stroke="none"
      strokeWidth="2.182"
      d="M12 10.91A1.09 1.09 0 0 0 10.91 12v4.364a1.09 1.09 0 0 0 1.09 1.09 1.09 1.09 0 0 0 1.09-1.09V12A1.09 1.09 0 0 0 12 10.91"
      color="#000"
    ></path>
    <path
      fill={color}
      stroke="none"
      strokeWidth="2.182"
      d="M12 6.545a1.09 1.09 0 0 0-1.09 1.091A1.09 1.09 0 0 0 12 8.727h.01a1.09 1.09 0 0 0 1.092-1.09 1.09 1.09 0 0 0-1.091-1.092Z"
      color="#000"
    ></path>
  </svg>
);

export default SvgIcon;

